// iOS only shows the keyboard for focus() that runs in the same turn as the
// tap. `await` queues a microtask, and that is already too late. Track the
// event turn itself: the flag is raised in the capture phase and dropped in
// the microtask queued there, which runs before an `await` continuation that
// was queued later in the same handler.

let depth = 0

function bump() {
	depth += 1
	queueMicrotask(() => {
		depth = Math.max(0, depth - 1)
	})
}

function install() {
	if (typeof window === 'undefined') return
	const scope = window as Window & { __owDirectGesture?: boolean }
	if (scope.__owDirectGesture) return
	scope.__owDirectGesture = true
	for (const type of ['touchend', 'pointerup', 'click', 'submit'] as const) {
		window.addEventListener(type, bump, true)
	}
}

install()

export function isDirectUserGesture(): boolean {
	return depth > 0
}
